module.exports = __webpack_public_path__ + "static/media/ts10sj.c2ac28b4.png";